import { http } from "../http/Http";
import { ObjectField } from "../models/ObjectField";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { ObjectFieldsTree } from "../models/ObjectFieldsTree";
import { ObjectFieldTreeItem } from "../models/ObjectFieldTreeItem";

export class ObjectFieldService {

    getObjectFieldsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<ObjectField[]>> => {
        const { data } = await http.post<ServiceResponse<ObjectField[]>>("ObjectField/GetByFilters", apiQueryFilter);
        return data;
    };

    getAllObjectField = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<ObjectField[]>> => {
        const { data } = await http.post<ServiceResponse<ObjectField[]>>("ObjectField/GetAll", apiQueryFilter);
        return data;
    };

    getObjectField = async (id: number): Promise<ObjectField> => {
        const { data } = await http.get<ObjectField>(("ObjectField/GetById/" + id.toString()));
        return data;
    };

    addObjectField = async (objectField: ObjectField): Promise<ObjectField> => {
        const { data } = await http.post<ObjectField>("ObjectField/Post", objectField);
        return data;
    };

    updateObjectField = async (objectField: ObjectField): Promise<ObjectField> => {
        const { data } = await http.put<ObjectField>("ObjectField/Put", objectField);
        return data;
    };

    getObjectFieldsTree = async (objectFieldsTree: ObjectFieldsTree): Promise<ObjectFieldTreeItem[]> => {
        const { data } = await http.post<ObjectFieldTreeItem[]>("ObjectField/GetObjectFieldsTree", objectFieldsTree);
        return data;
    };

}